import PromptInfo from '../utils/promptInfo.js';
import { Modal } from 'antd';
import {
  bookDel,
  cancelMeeting,
  cancelBatchMeeting,
  closeMeeting,
  delayMeeting,
  getBookingStatus,
  getExternal,
  getMeetingAuditLogs,
  getSvcAuditLogs,
  meetingSign,
  meetingSignOut,
  myReservationLists,
  saveOrUpdateExternal
} from '../services/meetingList';
import ReservationDialog from '../components/commons/ReservationDialog';
import { Base64 } from 'js-base64';
import { PATHS, SYSTEM_AUDIT_TYPE, PATH_HOME } from '../utils/constants';
import openDialog from '../components/commons/ScheduleDialog';
import { getZoneTreeData } from '../services/calender';
import moment from 'moment';
import { routerRedux } from 'dva/router';

const DialogType = PromptInfo.DialogType;
const DialogResult = PromptInfo.DialogResult;
const defaultPagination = {
  total: 0,
  currentPage: 1,
  pageSize: 10
};
export default {
  namespace: 'meetingList',
  state: {
    loading: false,
    data: {},
    pagination: { ...defaultPagination },
    meetingTree: { child: [] },
    filter: {
      status: [],
      reserveType: [], // "1" 我预约 “2” 我参加
      startDate: '', //开始时间
      endDate: '', //结束时间
      name: '', //会议名称
      roomIds: [], //会议室id
      endDateMoment: null,
      startDateMoment: null
    },
    auditLogs: [] //会议审批或会议服务审批的工作流信息
  },
  reducers: {
    set(state, { payload }) {
      return { ...state, ...payload };
    },
    setPagination(state, { payload }) {
      let newPagination = { ...state.pagination, ...payload };
      return { ...state, ...{ pagination: newPagination } };
    },
    setFilter(state, { payload }) {
      state.filter = { ...state.filter, ...payload };
      return { ...state };
    }
  },
  effects: {
    *allMeeting({ payload }, { call, put, select }) {
      yield put({ type: 'set', payload: { loading: true } });
      const locale = yield select(state => state.i18n.locale);
      const pagination = yield select(state => state.meetingList.pagination);
      const { meetingList } = yield select(state => state);
      payload.type = 3;
      let params = {
        ...{
          name: payload.name || '',
          pageSize: payload.pageSize || pagination.pageSize,
          pageNo: payload.currentPage || pagination.currentPage,
          id: payload.id || '',
          type: 3,
          lang: locale
        },
        ...{
          status: meetingList.filter.status,
          reserveType: meetingList.filter.reserveType,
          startDate: meetingList.filter.startDate,
          endDate: meetingList.filter.endDate,
          name: meetingList.filter.name,
          roomIds: meetingList.filter.roomIds
        }
      };
      const { status, data, msg } = yield call(myReservationLists, params);
      if (status === 0) {
        yield put({ type: 'set', payload: { data: data } });
        yield put({
          type: 'setPagination',
          payload: { currentPage: params.pageNo, pageSize: params.pageSize }
        });
        yield put({ type: 'set', payload: { loading: false } });
      } else {
        console.log('获取预约会议列表失败', status, msg);
        yield put({ type: 'set', payload: { loading: false } });
      }
    },
    *filterByStatus({ payload }, { call, put, select }) {
      const { meetingList } = yield select(state => state);
      const { filter } = meetingList;
      let newStatus = [];
      if (filter.status.some(s => s === payload.status)) {
        newStatus = filter.status.filter(s => s !== payload.status);
      } else {
        newStatus = filter.status.concat([payload.status]);
      }
      yield put({ type: 'setFilter', payload: { status: newStatus } });
      yield put({
        type: 'allMeeting',
        payload: {
          currentPage: defaultPagination.currentPage
          // pageSize: defaultPagination.pageSize
        }
      });
    },
    *search({ payload }, { call, put, select }) {
      yield put({
        type: 'allMeeting',
        payload: {
          currentPage: defaultPagination.currentPage
          // pageSize: defaultPagination.pageSize
        }
      });
    },
    *reset({ payload }, { call, put, select }) {
      let newFilter = {
        status: [],
        reserveType: [], // "1" 我预约 “2” 我参加
        startDate: '', //开始时间
        endDate: '', //结束时间
        name: '', //会议名称
        roomIds: [], //会议室id
        endDateMoment: null,
        startDateMoment: null
      };
      yield put({ type: 'setFilter', payload: newFilter });
      yield put({
        type: 'allMeeting',
        payload: {
          currentPage: defaultPagination.currentPage,
          pageSize: defaultPagination.pageSize
        }
      });
    },
    *filterByReserveType({ payload }, { call, put, select }) {
      const { meetingList } = yield select(state => state);
      const { filter } = meetingList;
      let newReserveType = [];
      if (filter.reserveType.some(s => s === payload.reserveType)) {
        newReserveType = filter.reserveType.filter(
          s => s !== payload.reserveType
        );
      } else {
        newReserveType = filter.reserveType.concat([payload.reserveType]);
      }
      yield put({
        type: 'setFilter',
        payload: { reserveType: newReserveType }
      });
      yield put({
        type: 'allMeeting',
        payload: {
          currentPage: defaultPagination.currentPage,
          pageSize: defaultPagination.pageSize
        }
      });
    },
    *getMeetingTreeData({ payload }, { call, put, select }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      yield put({ type: 'set', payload: { meetingTree: data.data } });
    },
    *cancelMeeting({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { messages } = yield select(state => state.i18n);
      let params = { meetingId: payload.id, type: payload.type, locale };
      const result = yield call(cancelMeeting, params);
      if (result.status == 0) {
        yield put({
          type: 'allMeeting',
          payload: {
            currentPage: defaultPagination.currentPage,
            pageSize: defaultPagination.pageSize
          }
        });
        Modal.success({ content: messages['cancel_meeting_success'], okText: messages['dialog_btn_ok'] });
      } else {
        Modal.error({ content: result.msg });
      }
    },
    *cancelBatchMeeting({ meetingData,resolve, reject }, { call, put, select }) {
      let meetingIds = [], type = [];
      meetingData.forEach(item=>{
        meetingIds.push(item.id);
        type.push(item.type);
      });
      const {locale} = yield select(state => state.i18n);
      let params = { meetingIds: meetingIds, type: type, locale };
      const {status,msg} = yield call(cancelBatchMeeting, params);
      if (status === 0) {
        yield put({
          type: 'allMeeting',
          payload: {
            currentPage: defaultPagination.currentPage,
            pageSize: defaultPagination.pageSize
          }
        });
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    *closeMeeting({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { messages } = yield select(state => state.i18n);
      console.info(messages);
      let params = { meetingId: payload.id, locale };
      const result = yield call(closeMeeting, params);
      if (result.status == 0) {
        yield put({
          type: 'allMeeting',
          payload: {
            currentPage: defaultPagination.currentPage,
            pageSize: defaultPagination.pageSize
          }
        });
        Modal.success({ content: messages['end_meeting_success'], okText: messages['dialog_btn_ok'] });
      } else {
        Modal.error({ content: result.msg });
      }
    },
    *delay(
      {
        payload: { meetingId, minutes, resolve, reject }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const { userId, domainName } = yield select(
        state => state.login.userInfo
      );
      const { status, msg } = yield call(delayMeeting, {
        interval: minutes,
        meetingId,
        userId: userId + '@' + domainName,
        locale
      });
      if (status == 0) {
        yield put({
          type: 'allMeeting',
          payload: {
            currentPage: defaultPagination.currentPage,
            pageSize: defaultPagination.pageSize
          }
        });
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    *signIn({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(meetingSign, { ...payload, locale });
      let type = DialogType.SUCCESS;
      if (result.status == 1) {
        type = DialogType.WARN;
        payload.prompt = result.msg;
      }
      const e = yield call(openDialog, {
        type: type,
        message: payload.prompt,
        locale: locale
      });
      if (e === DialogResult.OK || e === DialogResult.CANCEL) {
        if (filter !== '') {
          yield put({
            type: 'allMeeting',
            payload: Object.assign({}, filter, { type: 1 })
          });
          yield put({
            type: 'allMeeting',
            payload: Object.assign({}, filter, { type: 2 })
          });
        }
      }
    },
    *signOut({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(meetingSignOut, { ...payload, locale });
      let type = DialogType.SUCCESS;
      if (result.status == 1) {
        type = DialogType.WARN;
        payload.prompt = result.msg;
      }
      const e = yield call(openDialog, {
        type: type,
        message: payload.prompt,
        locale: locale
      });
      if (e === DialogResult.OK || e === DialogResult.CANCEL) {
        if (filter !== '') {
          yield put({
            type: 'allMeeting',
            payload: Object.assign({}, filter, { type: 1 })
          });
          yield put({
            type: 'allMeeting',
            payload: Object.assign({}, filter, { type: 2 })
          });
        }
      }
    },
    *del({ payload }, { call, put, select }) {
      const token =
        (yield select(state => state.login.token)) ||
        sessionStorage.getItem('token');
      const locale = yield select(state => state.i18n.locale);
      payload.token = token;
      const data = yield call(bookDel, { ...payload });
      const { success, pageSize, pageNo } = payload;
      const { status } = data;
      if (!data.msg) {
        data.msg = success;
      }
      const MeetingDialog = {
        type: status === 1 ? DialogType.ERROR : DialogType.SUCCESS,
        message: data.msg,
        locale: locale
      };
      ReservationDialog(MeetingDialog);
      if (data.status === 0) {
        if (pageNo) {
          yield put({
            type: 'allMeeting',
            payload: Object.assign(
              {},
              { pageSize: pageSize },
              { currentHistoryPage: pageNo },
              { type: 2 }
            )
          });
        } else {
          yield put({
            type: 'allMeeting',
            payload: Object.assign({}, { pageSize: pageSize }, { type: 2 })
          });
        }
      }
    },
    *getExternals(undefined, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(getExternal, locale);
      const externalData = JSON.parse(Base64.decode(data.data));
      yield put({ type: 'externalData', data: externalData });
    },
    *saveExternal({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      let { external, prompt } = payload;

      const result = yield call(saveOrUpdateExternal, { external, locale });
      let type = DialogType.SUCCESS;
      if (result && result.status === 1) {
        prompt = result.msg;
        type = DialogType.ERROR;
      }
      const e = yield call(openDialog, {
        type: type,
        message: prompt,
        locale: locale
      });
      if (e === DialogResult.OK && result.status === 0) {
        yield put({ type: 'getExternals' });
      }
    },
    *getAuditLogs({ meetingId, auditType, resolve, reject }, { call, put }) {
      const { data, status, msg } = yield call(
        auditType === SYSTEM_AUDIT_TYPE.meeting
          ? getMeetingAuditLogs
          : getSvcAuditLogs,
        meetingId
      );
      if (status === 0) {
        yield put({ type: 'set', payload: { auditLogs: data } });
      } else {
        reject && reject(msg);
      }
    },
    *bookAgain({ meetingId }, { select, call, put }) {
      const { status } = yield call(getBookingStatus, meetingId);
      const { messages } = yield select(state => state.i18n);
      if (0 == status) {
        yield put(
          routerRedux.push(`${PATHS.meetingInfo}?reserveMeetingId=${meetingId}`)
        );
      } else {
        Modal.error({ content: messages['meeting_book_jurisdiction_fail'] });
      }
    }
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === `${PATH_HOME}list`) {
          let filter = {
            status: [],
            reserveType: [],
            startDate: '',
            endDate: '',
            name: '',
            roomIds: [],
            endDateMoment: null,
            startDateMoment: null
          };
          dispatch({ type: 'set', payload: { filter } });
          dispatch({
            type: 'allMeeting',
            payload: {
              currentPage: defaultPagination.currentPage,
              pageSize: defaultPagination.pageSize
            }
          });
          dispatch({ type: 'getMeetingTreeData', payload: {} });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingList.js